import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=5c6dbb70&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"
import style0 from "./Series.vue?vue&type=style&index=0&id=5c6dbb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dbb70",
  null
  
)

export default component.exports